
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexTE_458U5mmI6uwTjjDPa0itySp9vR76J2ywX6E1himjlUMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/index.vue?macro=true";
import { default as indexmG_7b5kinJVr4l6whKepRLuMku8syvy_45nE1i8LeSE5kMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/user/index.vue?macro=true";
import { default as indexETiocWviRXFhl8RX1WNfSiCqVGqIFvGGC8Rd8A0COzgMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/index.vue?macro=true";
import { default as loginVSuotrHMwrVhsz84oTLo4pADK2uZeQLjjJHXzoYM0FIMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/login.vue?macro=true";
import { default as welcomespWG8BXZzKl4c9c1HFzxHk6HeMc8go_KPdx8uSJEWtgMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/welcome.vue?macro=true";
import { default as indexrxx1HFzR1U_5Xn6fGt31w0sxYOwkCZEv29e1pVr6_6IMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/me/index.vue?macro=true";
import { default as autologinueAEjBzITLMO36uXE1RXAjDuRldKyw_jA30b4faYTLwMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/autologin.vue?macro=true";
import { default as indexHGXQcYcWqjXfNPbs7N_8twKCaBcpdVs6kZuhgVv44msMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/join/index.vue?macro=true";
import { default as indexHpfK3fNBsneiT_oIv2k90RzPOMSBb74cT8DlSI_81cIMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/webapp-user/index.vue?macro=true";
import { default as indexQEQXhOT8gxpg7r4IMJkWOCNrcj5qutrTjsliXSPSDSQMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/invite/index.vue?macro=true";
import { default as indexQF9cyI2EzU9_45vK_45MKiZghjH6UemSbUvwq0sPgVf5YF8Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option/index.vue?macro=true";
import { default as indexmhcgIJ9XItoiJDs7kkFmuDD_19IPwyR4PZuCzxhnqy8Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/webapp-admin/index.vue?macro=true";
import { default as group_45messageXeK3rxKrGVZVMMRYX_QKjrdrHeDcRxgBYNFR8eEMeh0Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/group-message.vue?macro=true";
import { default as indexJjvP1atzelPv8fmZ5uR7K4VmNt5rj9_45MSm4xV59zRCMMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/message/index.vue?macro=true";
import { default as createE3FyxiS8jzGP5e9oj3nlHbjEFlrlD_O5H6aUjAeZWjMMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option/create.vue?macro=true";
import { default as receiveM_45zKfXhyU3KC2kzG7awWVndyhDfGDAv4A1BRnCfZvM4Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/order/receive.vue?macro=true";
import { default as indexCBxTqeWMd2gVxhJmxJzMNm3OR8MWr47MlwMpXyMxWwgMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/product/index.vue?macro=true";
import { default as indexsL3TbK3BfSvy4P5p2BVfz6L20yRlxozNxcs32oGrkV0Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/category/index.vue?macro=true";
import { default as createdkOGpf_45blXx_eSplDWgV5P26weBPbutq3NazW35_45LLkMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/product/create.vue?macro=true";
import { default as index0Q7r_XjnX3USGYNXpa26_XZVSuuqK070iY21OqjEGYoMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/index.vue?macro=true";
import { default as createuQLJI4sMf_45IamEGIaDCYI7EFNAFcJWEeA_VaNekfONgMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/category/create.vue?macro=true";
import { default as index9duFejCAZ4gjhMc5_7Uzu4iRr0R6y3hp5PivnFSQ8rUMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/dashboard/index.vue?macro=true";
import { default as index3HDAn0CQDRMuADvyJVSnWBbcbm8iev4ZjPrdEvkYO34Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/super/companies/index.vue?macro=true";
import { default as registerYo12IloS6_4580ex2oXkHgyC4vlXHv0JuCZgX6vMIRonwMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/company/register.vue?macro=true";
import { default as sendIMSPniKeotEyhsGBvWfYpIe_DkSYWbtOaQa4hy06EYwMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/consignment/send.vue?macro=true";
import { default as indexn_45_45Xnf71c8y7B2Y09rdj3urOnPUoASPTvDsX1h9mRYgMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/LoginToken/index.vue?macro=true";
import { default as _91id_939uzgZY6ZlqOhSP7s_45kCx_45TDItGNged1xAqDiTJ5vlJIMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option/edit/[id].vue?macro=true";
import { default as indexJgWKX9eU_xMx_lxmRmkOKLxIlbyQrKRec3ahLw9PQ2YMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/user/[companyId]/index.vue?macro=true";
import { default as indexnfjKDCZhcXHo1_451dodx9hFdLVJrdWaLEsd7d02dZ63sMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/consignment/index.vue?macro=true";
import { default as _91id_93MsrRge9I61od4yysN6LJAgUeEIBiKCD6wQ3WgDPhQmQMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/product/edit/[id].vue?macro=true";
import { default as indexuDGKqwuFjO1V5D9kcOWxV0TKwisjS32XVuUbR1SfKG8Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/super/admin-users/index.vue?macro=true";
import { default as _91id_93fnYjD_kL2bWRZDw4mMyDbycvGBNySuahf74rx5m4_45_MMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/category/edit/[id].vue?macro=true";
import { default as indexBvAlCDWnI9SlF0VV_45PAdcOJs58YYUpFyNAVwCvCO_8QMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option-group/index.vue?macro=true";
import { default as auto_45send1gIdVBOGBv54MXm7bVsaFSST7HvkAbStulYEzWuY09wMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/auto-send.vue?macro=true";
import { default as batchesSnWe_45wQWyT0gIsXrq57TGapNwAR_45aTDPFIfmhowg8tYMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/consignment/batches.vue?macro=true";
import { default as indexJz3lFSk6yalEFDntY_b611gH2Q4GlB8evr7gqs_45jLCsMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/courier-print/index.vue?macro=true";
import { default as createR642taY1m0PSQKJ8goHStWnE3z1HALL0aJc3F1PwQSYMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option-group/create.vue?macro=true";
import { default as index1Xa_0rmQBYw_45N9ZXuD3xfQ_45YEGQZEiTq4F9LKzkxtYsMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/order-data-v2/index.vue?macro=true";
import { default as kakao_45channelPdh9xSa_FI7vxh5kfe5fbJ58Z8F_45jOJ39PG6v5sJ1cAMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/company/kakao-channel.vue?macro=true";
import { default as tracking_45notificationq2RkKBhK0M7z0JVK0HkSncPB5nus5uq1Nhi_45bwcMKToMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/tracking-notification.vue?macro=true";
import { default as _91id_93LH_45eBMMz5kHfkS9aC999SjZKtFIPbuzVNZ3PJ1AuRIMMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option-group/edit/[id].vue?macro=true";
import { default as sms_45templatesxLT7TCyiXxqS5u5khd2HB3spws3d8HGsC7oznwZPWFQMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/sms-templates.vue?macro=true";
import { default as bulk_45upload_Xkrj51jC7h4zN_45q_BTMIYZ0XACP9EU7Z1mL5hfTIekMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/consignment/bulk-upload.vue?macro=true";
import { default as kakao_45channel_45guidegANXnhWIVUPT3kJIFGSss4WPg58hhhJdeIk9AoRK1YYMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/join/kakao-channel-guide.vue?macro=true";
import { default as indexUy8uIMO4Hdd6k89tl_45jUu_3iCEqOu42HQh_45BDdIXL78Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/market-keys/index.vue?macro=true";
import { default as edit_45business_45hoursRV9rYCWUdexqFtRVixXWgppsYjzyzANZ3fd_Or5ukKQMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/company/edit-business-hours.vue?macro=true";
import { default as sender_45settingsmUchQztkzMi4J6trwI0EpFzEsNjFZAt3oCxH4Z6djm0Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/consignment/sender-settings.vue?macro=true";
import { default as index8mGX8P2zyHo8MxfU7fFFv9A7ID6LQREcmcGMYwO8fHMMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/courier-transmissions/index.vue?macro=true";
import { default as edit_45delivery_45configBSeAIUSpUU4GZ9eDSkTKRGRA4FNK7aL2H2CZzYXPTf4Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/company/edit-delivery-config.vue?macro=true";
import { default as indexuWb6T6Paa_HdCLGJ5WBG5mhIJf7UOgv64wtsCQUugVQMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/bank-settings/index.vue?macro=true";
import { default as indexFutliOZBVmlhl43byiswcPiP7x4erdrErw3j_45CqqxG0Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/menu-settings/index.vue?macro=true";
import { default as _91platform_93wMDKQPn9txwiCyFq_Z3GZF5JBmFGWEMkdtLzhWGAggcMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/market-keys/[platform].vue?macro=true";
import { default as indexsLW8ScsG5vEjOjq0LUcCoj2rWVbLlh49f6AI8D6NNisMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/statistics/monthly-orders/index.vue?macro=true";
import { default as addcNE2nX0TsuX3S1St2A7y_AYo_45o6mvqntWvWK8Ik_45txcMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/courier-management-saas/add.vue?macro=true";
import { default as indexTMRNVhn_YyhpxCFkA72m0_45TPWUpP3LJSqXGKvvEM0HEMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/stamp-coupon-settings/index.vue?macro=true";
import { default as createl0FBli3dOZt_45NoCQosJ4SmWMpBUbT198C_ofeZN8ifYMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/stamp-coupon-settings/create.vue?macro=true";
import { default as index2iE3WbfYHB4eg4sfsgFw_zqLq5Z13lsmA0P6F0IZnNMMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/courier-management-saas/index.vue?macro=true";
import { default as _91id_93GjKmmil14QrpeU9CzGWILZlrpsMcxc_fA5LYIAqygn4Meta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/stamp-coupon-settings/edit/[id].vue?macro=true";
import { default as _91id_93K9pj0XOGMemlkGMPAPbSaepDMD91tzJcodfjOZISo_45EMeta } from "/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/courier-management-saas/edit/[id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexTE_458U5mmI6uwTjjDPa0itySp9vR76J2ywX6E1himjlUMeta || {},
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/index.vue")
  },
  {
    name: "user",
    path: "/user",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/user/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    meta: loginVSuotrHMwrVhsz84oTLo4pADK2uZeQLjjJHXzoYM0FIMeta || {},
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/login.vue")
  },
  {
    name: "admin-welcome",
    path: "/admin/welcome",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/welcome.vue")
  },
  {
    name: "admin-me",
    path: "/admin/me",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/me/index.vue")
  },
  {
    name: "admin-autologin",
    path: "/admin/autologin",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/autologin.vue")
  },
  {
    name: "admin-join",
    path: "/admin/join",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/join/index.vue")
  },
  {
    name: "webapp-user",
    path: "/webapp-user",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/webapp-user/index.vue")
  },
  {
    name: "admin-invite",
    path: "/admin/invite",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/invite/index.vue")
  },
  {
    name: "admin-option",
    path: "/admin/option",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option/index.vue")
  },
  {
    name: "webapp-admin",
    path: "/webapp-admin",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/webapp-admin/index.vue")
  },
  {
    name: "admin-group-message",
    path: "/admin/group-message",
    meta: group_45messageXeK3rxKrGVZVMMRYX_QKjrdrHeDcRxgBYNFR8eEMeh0Meta || {},
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/group-message.vue")
  },
  {
    name: "admin-message",
    path: "/admin/message",
    meta: indexJjvP1atzelPv8fmZ5uR7K4VmNt5rj9_45MSm4xV59zRCMMeta || {},
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/message/index.vue")
  },
  {
    name: "admin-option-create",
    path: "/admin/option/create",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option/create.vue")
  },
  {
    name: "admin-order-receive",
    path: "/admin/order/receive",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/order/receive.vue")
  },
  {
    name: "admin-product",
    path: "/admin/product",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/product/index.vue")
  },
  {
    name: "admin-category",
    path: "/admin/category",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/category/index.vue")
  },
  {
    name: "admin-product-create",
    path: "/admin/product/create",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/product/create.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/index.vue")
  },
  {
    name: "admin-category-create",
    path: "/admin/category/create",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/category/create.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/dashboard/index.vue")
  },
  {
    name: "super-companies",
    path: "/super/companies",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/super/companies/index.vue")
  },
  {
    name: "admin-company-register",
    path: "/admin/company/register",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/company/register.vue")
  },
  {
    name: "admin-consignment-send",
    path: "/admin/consignment/send",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/consignment/send.vue")
  },
  {
    name: "admin-LoginToken",
    path: "/admin/LoginToken",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/LoginToken/index.vue")
  },
  {
    name: "admin-option-edit-id",
    path: "/admin/option/edit/:id()",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option/edit/[id].vue")
  },
  {
    name: "user-companyId",
    path: "/user/:companyId()",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/user/[companyId]/index.vue")
  },
  {
    name: "admin-consignment",
    path: "/admin/consignment",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/consignment/index.vue")
  },
  {
    name: "admin-product-edit-id",
    path: "/admin/product/edit/:id()",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/product/edit/[id].vue")
  },
  {
    name: "super-admin-users",
    path: "/super/admin-users",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/super/admin-users/index.vue")
  },
  {
    name: "admin-category-edit-id",
    path: "/admin/category/edit/:id()",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/category/edit/[id].vue")
  },
  {
    name: "admin-option-group",
    path: "/admin/option-group",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option-group/index.vue")
  },
  {
    name: "admin-settings-auto-send",
    path: "/admin/settings/auto-send",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/auto-send.vue")
  },
  {
    name: "admin-consignment-batches",
    path: "/admin/consignment/batches",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/consignment/batches.vue")
  },
  {
    name: "admin-courier-print",
    path: "/admin/courier-print",
    meta: indexJz3lFSk6yalEFDntY_b611gH2Q4GlB8evr7gqs_45jLCsMeta || {},
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/courier-print/index.vue")
  },
  {
    name: "admin-option-group-create",
    path: "/admin/option-group/create",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option-group/create.vue")
  },
  {
    name: "admin-order-data-v2",
    path: "/admin/order-data-v2",
    meta: index1Xa_0rmQBYw_45N9ZXuD3xfQ_45YEGQZEiTq4F9LKzkxtYsMeta || {},
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/order-data-v2/index.vue")
  },
  {
    name: "admin-company-kakao-channel",
    path: "/admin/company/kakao-channel",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/company/kakao-channel.vue")
  },
  {
    name: "admin-tracking-notification",
    path: "/admin/tracking-notification",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/tracking-notification.vue")
  },
  {
    name: "admin-option-group-edit-id",
    path: "/admin/option-group/edit/:id()",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/option-group/edit/[id].vue")
  },
  {
    name: "admin-settings-sms-templates",
    path: "/admin/settings/sms-templates",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/sms-templates.vue")
  },
  {
    name: "admin-consignment-bulk-upload",
    path: "/admin/consignment/bulk-upload",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/consignment/bulk-upload.vue")
  },
  {
    name: "admin-join-kakao-channel-guide",
    path: "/admin/join/kakao-channel-guide",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/join/kakao-channel-guide.vue")
  },
  {
    name: "admin-settings-market-keys",
    path: "/admin/settings/market-keys",
    meta: indexUy8uIMO4Hdd6k89tl_45jUu_3iCEqOu42HQh_45BDdIXL78Meta || {},
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/market-keys/index.vue")
  },
  {
    name: "admin-company-edit-business-hours",
    path: "/admin/company/edit-business-hours",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/company/edit-business-hours.vue")
  },
  {
    name: "admin-consignment-sender-settings",
    path: "/admin/consignment/sender-settings",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/consignment/sender-settings.vue")
  },
  {
    name: "admin-courier-transmissions",
    path: "/admin/courier-transmissions",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/courier-transmissions/index.vue")
  },
  {
    name: "admin-company-edit-delivery-config",
    path: "/admin/company/edit-delivery-config",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/company/edit-delivery-config.vue")
  },
  {
    name: "admin-settings-bank-settings",
    path: "/admin/settings/bank-settings",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/bank-settings/index.vue")
  },
  {
    name: "admin-settings-menu-settings",
    path: "/admin/settings/menu-settings",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/menu-settings/index.vue")
  },
  {
    name: "admin-settings-market-keys-platform",
    path: "/admin/settings/market-keys/:platform()",
    meta: _91platform_93wMDKQPn9txwiCyFq_Z3GZF5JBmFGWEMkdtLzhWGAggcMeta || {},
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/market-keys/[platform].vue")
  },
  {
    name: "admin-statistics-monthly-orders",
    path: "/admin/statistics/monthly-orders",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/statistics/monthly-orders/index.vue")
  },
  {
    name: "admin-settings-courier-management-saas-add",
    path: "/admin/settings/courier-management-saas/add",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/courier-management-saas/add.vue")
  },
  {
    name: "admin-settings-stamp-coupon-settings",
    path: "/admin/settings/stamp-coupon-settings",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/stamp-coupon-settings/index.vue")
  },
  {
    name: "admin-settings-stamp-coupon-settings-create",
    path: "/admin/settings/stamp-coupon-settings/create",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/stamp-coupon-settings/create.vue")
  },
  {
    name: "admin-settings-courier-management-saas",
    path: "/admin/settings/courier-management-saas",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/courier-management-saas/index.vue")
  },
  {
    name: "admin-settings-stamp-coupon-settings-edit-id",
    path: "/admin/settings/stamp-coupon-settings/edit/:id()",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/stamp-coupon-settings/edit/[id].vue")
  },
  {
    name: "admin-settings-courier-management-saas-edit-id",
    path: "/admin/settings/courier-management-saas/edit/:id()",
    component: () => import("/Users/jaeyounghyun/dev/farmsns/farmsns-sumwork/farmfree/packages/farmfree-admin/pages/admin/settings/courier-management-saas/edit/[id].vue")
  }
]